import {
  DEACTIVE,
  DELETE,
  GET_CATEGORIES,
  GET_CATEGORY_FILE_SUB_TYPE,
  GET_CATEGORY_LIST,
  GET_DETAIL,
  GET_REFERENCE_DATA_DETAIL,
  SET_LOADING,
  SUBMIT_DATA,
  UPDATE,
} from '../types/category';

export function getCategories(params) {
  return { type: GET_CATEGORIES, payload: { params } };
}

export function getCategoryList(params) {
  return { type: GET_CATEGORY_LIST, payload: { params } };
}

export function getCategoryDetail(params) {
  return { type: GET_DETAIL, params };
}

export function setLoading(isLoading = false) {
  return { type: SET_LOADING, isLoading };
}

export function getReferenceData(params) {
  return { type: GET_REFERENCE_DATA_DETAIL, params };
}

export function submitCategory(params, callback = null) {
  return { type: SUBMIT_DATA, params, callback };
}

export function deactiveCategory(id, callback = null) {
  return { type: DEACTIVE, id, callback };
}

export function deleteCategory(id, callback = null) {
  return { type: DELETE, id, callback };
}

export function updateCategory(params, callback = null) {
  return { type: UPDATE, params, callback };
}

export function getCategoryFileSubType(callback = null) {
  return { type: GET_CATEGORY_FILE_SUB_TYPE, callback };
}
